import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description'; // Example icon
import Image from 'next/image';
import { IMAGES } from '@/lib/constants';

const LoanDisbursedInfo = () => {
    return (
        <Box display="flex" alignItems="center" p={1} borderRadius={'40px'} bgcolor={'#fff'}>
            {/* Circular Icon */}
            <Avatar
                sx={{
                    bgcolor: '#E9FFE6',
                    width: 48,
                    height: 48,
                    mr: 2,
                }}
            >
                <Image
                    src={IMAGES.documentDark}
                    alt={`document`}
                    loading="lazy"
                    width={35}
                    height={35}
                    borderRadius={'50%'}
                />
            </Avatar>

            {/* Text */}
            <Typography fontSize={'12px'} color={'#627A95'}>
                Loan disbursed in every 30 seconds
            </Typography>
        </Box>
    );
};

export default LoanDisbursedInfo;
